import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, withModifiers as _withModifiers, renderList as _renderList, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6541cffc")

_pushScopeId("data-v-6541cffc")
const _hoisted_1 = { class: "courier-table-wrap" }
const _hoisted_2 = {
  key: 1,
  class: "px-4 py-6"
}
const _hoisted_3 = { class: "sticky -top-0.5 z-10 bg-white" }
const _hoisted_4 = { class: "text-gray-lp-300 border-b border-t border-gray-lp-1400" }
const _hoisted_5 = { class: "p-2 py-5 w-8" }
const _hoisted_6 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_7 = { class: "p-2 py-3" }
const _hoisted_8 = {
  key: 3,
  class: "bg-white border-t px-2"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_TableLazyLoad = _resolveComponent("TableLazyLoad")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_EmptyList = _resolveComponent("EmptyList")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_PaginationV3 = _resolveComponent("PaginationV3")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.errorCause && !_ctx.tableData.length && !_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          errorType: _ctx.errorCause,
          onTryAgain: _ctx.fetchListSummary
        }, null, 8, ["errorType", "onTryAgain"]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_TableLazyLoad, {
          key: 1,
          columns: _ctx.columns
        }, null, 8, ["columns"]))
      : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
          (!_ctx.tableData.length)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                (!_ctx.tableData.length && _ctx.isFiltering && !_ctx.errorCause && !_ctx.isLoading)
                  ? (_openBlock(), _createBlock(_component_EmptyState, {
                      key: 0,
                      icon: "ill_spot_search",
                      customHeaderMessage: _ctx.$t('pickupDashboard.emptyState.searchNotFound'),
                      customMessage: _ctx.$t('pickupDashboard.emptyState.searchNotFoundHint')
                    }, null, 8, ["customHeaderMessage", "customMessage"]))
                  : _createCommentVNode("", true),
                (!_ctx.isFiltering && !_ctx.errorCause)
                  ? (_openBlock(), _createBlock("div", _hoisted_2, [
                      _createVNode(_component_EmptyList, {
                        data: "data",
                        customHeaderMessage: _ctx.$t('pickupDashboard.emptyState.noPackage'),
                        customMessage: _ctx.$t('pickupDashboard.emptyState.noPackageHint')
                      }, null, 8, ["customHeaderMessage", "customMessage"])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createBlock("div", {
                key: 1,
                class: "courier-table",
                style: {
            maxHeight: `calc(calc(100vh / var(--viewport-scale)) - ${_ctx.effectiveSubtractHeight}px)`,
          }
              }, [
                _createVNode("table", null, [
                  _createVNode("thead", _hoisted_3, [
                    _createVNode("tr", _hoisted_4, [
                      _createVNode("th", _hoisted_5, [
                        _createVNode("div", {
                          class: ["w-5 h-5 rounded flex items-center justify-center cursor-pointer", 
                      _ctx.isAllSelected
                        ? 'bg-red-lp-100'
                        : 'border border-gray-lp-300'
                    ],
                          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args)), ["stop"]))
                        }, [
                          (_ctx.isAllSelected)
                            ? (_openBlock(), _createBlock(_component_Icons, {
                                key: 0,
                                name: "check",
                                class: "w-4 h-4 text-white"
                              }))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                        return (_openBlock(), _createBlock("th", {
                          key: col.key,
                          class: ["p-2 py-5 select-none", [
                    col.style?.textAlign === 'center'
                      ? 'text-center'
                      : 'text-left',
                  ]],
                          style: { ...col.style }
                        }, [
                          _createVNode("div", {
                            class: ["flex items-center gap-2", [
                      _ctx.enableSort && col.sortable ? 'cursor-pointer' : '',
                      col.style?.textAlign === 'center' ? 'justify-center' : '',
                    ]],
                            onClick: ($event: any) => (_ctx.onSort(col))
                          }, [
                            _createVNode("span", null, _toDisplayString(_ctx.$t(col.label)), 1),
                            (_ctx.enableSort && col.sortable)
                              ? (_openBlock(), _createBlock("span", _hoisted_6, [
                                  (_ctx.sortKey !== col.key)
                                    ? (_openBlock(), _createBlock("img", {
                                        key: 0,
                                        src: 
                          require('@/app/ui/assets/svg/ics_o_chevron_sort.svg')
                        ,
                                        alt: "Sort Desc"
                                      }, null, 8, ["src"]))
                                    : (_ctx.sortOrder === 'asc')
                                      ? (_openBlock(), _createBlock("img", {
                                          key: 1,
                                          src: 
                          require('@/app/ui/assets/svg/ics_o_chevron_sort_asc.svg')
                        ,
                                          alt: "Sort Asc"
                                        }, null, 8, ["src"]))
                                      : (_openBlock(), _createBlock("img", {
                                          key: 2,
                                          src: 
                          require('@/app/ui/assets/svg/ics_o_chevron_sort_desc.svg')
                        
                                        }, null, 8, ["src"]))
                                ]))
                              : _createCommentVNode("", true)
                          ], 10, ["onClick"])
                        ], 6))
                      }), 128))
                    ])
                  ]),
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                      return (_openBlock(), _createBlock("tr", {
                        key: item.taskId,
                        class: "text-sm border-b border-gray-lp-1400 hover:bg-gray-50 text-gray-lp-300"
                      }, [
                        _createVNode("td", _hoisted_7, [
                          _createVNode("div", {
                            class: ["w-5 h-5 rounded flex items-center justify-center", [
                      _ctx.isRestrictedTab && !item.isAbleToBooking
                        ? 'bg-gray-200 border border-gray-300 cursor-not-allowed'
                        : _ctx.isSelected(item)
                        ? 'bg-red-lp-100 cursor-pointer'
                        : 'border border-gray-lp-500 cursor-pointer',
                    ]],
                            onClick: _withModifiers(($event: any) => (
                      (!_ctx.isRestrictedTab || item.isAbleToBooking) &&
                        _ctx.toggleRow(item)
                    ), ["stop"])
                          }, [
                            (_ctx.isSelected(item))
                              ? (_openBlock(), _createBlock(_component_Icons, {
                                  key: 0,
                                  name: "check",
                                  class: "w-4 h-4 text-white"
                                }))
                              : _createCommentVNode("", true)
                          ], 10, ["onClick"])
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                          return (_openBlock(), _createBlock("td", {
                            key: col.key,
                            class: "p-2 py-3",
                            style: { ...col.style }
                          }, [
                            _renderSlot(_ctx.$slots, `cell-${col.key}`, {
                              item: item,
                              index: index,
                              tick: _ctx.tick,
                              formatRemaining: _ctx.formatRemaining,
                              getTimeColor: _ctx.getTimeColor
                            }, () => [
                              (col.key === 'no')
                                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_ctx.startIndex + index + 1), 1)
                                  ], 64))
                                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(_ctx.getCellValue(item, col.key)), 1)
                                  ], 64))
                            ], true)
                          ], 4))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ])
              ], 4))
        ], 64)),
    (_ctx.tableData.length && !_ctx.isLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_8, [
          _createVNode(_component_PaginationV3, {
            pagination: _ctx.pagination,
            onSetPage: _ctx.onSetPage,
            renderedData: _ctx.tableData.length,
            paginationWidth: "w-full",
            paginationPaddingVertical: "py-2"
          }, null, 8, ["pagination", "onSetPage", "renderedData"])
        ]))
      : _createCommentVNode("", true)
  ]))
})